import type { GroupChatMessage } from '../../../types/groups';

interface GroupMessageItemProps {
  message: GroupChatMessage;
}

function getInitials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');
}

export default function GroupMessageItem({ message }: GroupMessageItemProps) {
  const createdDate = new Date(message.createdAt);
  const time = Number.isNaN(createdDate.getTime())
    ? message.createdAt
    : createdDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  return (
    <div className={`flex ${message.isOwnMessage ? 'justify-end' : 'justify-start'}`}>
      <div className={`flex max-w-[88%] gap-3 sm:max-w-[70%] ${message.isOwnMessage ? 'flex-row-reverse' : 'flex-row'}`}>
        {!message.isOwnMessage && (
          <div className="flex-shrink-0">
            {message.senderPhoto ? (
              <img
                src={message.senderPhoto}
                alt={message.senderName}
                className="h-9 w-9 rounded-full object-cover"
              />
            ) : (
              <div className="flex h-9 w-9 items-center justify-center rounded-full bg-blue-100 text-xs font-bold text-blue-700">
                {getInitials(message.senderName)}
              </div>
            )}
          </div>
        )}

        <div className={`flex flex-col ${message.isOwnMessage ? 'items-end' : 'items-start'}`}>
          <div className={`mb-1 flex items-center gap-2 text-xs ${message.isOwnMessage ? 'justify-end' : 'justify-start'}`}>
            {!message.isOwnMessage && (
              <span className="font-semibold text-gray-700">{message.senderName}</span>
            )}
            <span className="text-gray-400">{time}</span>
          </div>
          <div
            className={`rounded-2xl px-4 py-3 text-sm leading-6 shadow-sm ${
              message.isOwnMessage
                ? 'rounded-br-md bg-blue-600 text-white'
                : 'rounded-bl-md border border-gray-100 bg-gray-100 text-gray-800'
            }`}
          >
            <p className="mb-0 whitespace-pre-wrap break-words">{message.messageText}</p>
            {message.attachmentUrl && (
              <div className="mt-2">
                <a
                  href={message.attachmentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`text-xs underline ${message.isOwnMessage ? 'text-blue-100' : 'text-blue-600'}`}
                >
                  View Attachment
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
